const API_URL = process.env.REACT_APP_API_URL || "https://project-backend-eta-pink.vercel.app/api";

const getToken = () => sessionStorage.getItem("token");

const apiRequest = async (endpoint, options = {}) => {
    const token = getToken();

    const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
        ...options.headers,
    };

    const response = await fetch(`${API_URL}${endpoint}`, {
        ...options,
        headers,
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data.message || "Something went wrong");
    }

    return data;
};

export const authAPI = {
    register: (userData) =>
        apiRequest("/auth/register", {
            method: "POST",
            body: JSON.stringify(userData),
        }),

    login: (credentials) =>
        apiRequest("/auth/login", {
            method: "POST",
            body: JSON.stringify(credentials),
        }),

    logout: () =>
        apiRequest("/auth/logout", { method: "POST" }),

    getCurrentUser: () => apiRequest("/auth/me"),
};

export { apiRequest, getToken };